import { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './Teacher.module.css';

import {
  DETAIL,
  EMAIL,
  GRADE,
  NAME,
  NICKNAME,
  SCHOOL_GRADE,
  SETTINGS,
  SUBJECT,
  TEACHER_INFORMATION,
} from '../../../constants';
import Search from '../Search';
import Table from '../Table';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import {
  selectTeacherList,
  selectTeacherPage,
  selectTeacherSearch,
  selectTeacherTotalCnt,
  teacherListChanged,
  teacherPageChanged,
  teacherTotalCntSet,
} from '../../../features/classroomSlice';
import {
  selectAllTeacher,
  teacherApiSlice,
  useGetTeacherQuery,
} from '../../../services/teacher';

export default function Teacher() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();

  const list = useAppSelector(selectTeacherList);
  const page = useAppSelector(selectTeacherPage);
  const keyword = useAppSelector(selectTeacherSearch);
  const entities = useAppSelector(selectAllTeacher);
  const totalCnt = useAppSelector(selectTeacherTotalCnt);

  const { data: teacherData, isLoading } = useGetTeacherQuery({
    page: 0,
    search: keyword,
  });
  const [getTeacherList] = teacherApiSlice.useLazyGetTeacherQuery();

  const headerList = [
    'nm',
    'alias',
    'schoolTypeNm',
    'gradeTypeNm',
    'subjectTypeNm',
    'email',
    'dispStatus',
    'details',
  ];
  const headerName = {
    nm: NAME,
    alias: NICKNAME,
    schoolTypeNm: SCHOOL_GRADE,
    gradeTypeNm: GRADE,
    subjectTypeNm: SUBJECT,
    email: EMAIL,
    dispStatus: SETTINGS,
    details: DETAIL,
  };

  const updateList = async () => {
    try {
      await getTeacherList({
        page,
        search: keyword,
      }).unwrap();
    } catch (error) {
      console.error('Fail to get list', error);
    }
  };

  useEffect(() => {
    updateList();
  }, [page, keyword]);

  useEffect(() => {
    dispatch(teacherTotalCntSet(teacherData?.totalCnt));
    dispatch(teacherListChanged(entities));
  }, [entities]);

  if (isLoading) return null;

  return (
    <>
      <h2>{TEACHER_INFORMATION}</h2>

      <div className={cx('option_area')}>
        <Search type={'teacher'} keyword={keyword} total={totalCnt} />
      </div>

      <Table
        name={'teacher'}
        headerList={headerList}
        headerName={headerName}
        list={list}
        updateList={updateList}
        pageChanged={teacherPageChanged}
      />
    </>
  );
}
